import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  get_driver_detail,
  get_order_detail,
  get_vendor_detail,
} from "../../utils/api";
import {
  Box,
  Card,
  Flex,
  Heading,
  Input,
  Select,
  SimpleGrid,
  Stack,
  Text,
  VStack,
  useDisclosure,
} from "@chakra-ui/react";
import CustomButton from "../../components/ButtonComp";
import { BiArrowBack } from "react-icons/bi";
import DisplayData from "../../components/DisplayData";
import Loader from "../../components/Loader";
import ImageModal from "../../components/ImageModal";
import { baseUrl, formatCurrency } from "../../utils/utils";
import CustomDataCard from "../../components/CustomDataCard";

const PurchaseDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const { onOpen, onClose, isOpen } = useDisclosure();
  const [url, setUrl] = useState("");

  const purchaseData = location?.state || {};

  // Convert customer data to card format
  const createCustomerCardData = (customer) => [
    {
      key: "Product Name",
      value: customer.product_name,
      valueWeight: "semibold",
    },
    // { key: "Type", value: customer.type, valueWeight: "medium" },
    { key: "Quantity", value: customer.quantity, valueWeight: "medium" },
    {
      key: "Unit Price",
      value: formatCurrency(customer.unit_price),
      valueWeight: "medium",
    },
    {
      key: "GST",
      value: customer.gst + "%",
      valueWeight: "medium",
    },
    {
      key: "Empty Returned",
      value: customer.empty_returned,
      valueWeight: "medium",
    },
    {
      key: "Discount",
      value: formatCurrency(customer.discount),
      valueWeight: "medium",
    },
    {
      key: "GST Amount",
      value: formatCurrency(customer.gst_amount),
      valueWeight: "medium",
    },
    {
      key: "Taxable Amount",
      value: formatCurrency(customer.taxable_amount),
      valueWeight: "medium",
    },
  ];
  return (
    <>
      <Card
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        justify={"space-between"}
        paddingInline={5}
        paddingBlock={2}
      >
        <Heading fontSize={"xl"}>Purchase Details</Heading>
        <CustomButton
          icon={<BiArrowBack color="#fff" />}
          title={"Back"}
          height={"30px"}
          b_color={"#000"}
          onClick={() =>
            navigate("/purchase", {
              state: {
                fromList: true,
                page: location.state?.page || 1,
                rows: location.state?.rows || 5,
                initialValue: location.state?.initialValue || 1,
              },
            })
          }
        />

      </Card>

      <Stack>
        <Card
          paddingInline={5}
          paddingBlock={2}
        // cursor={"pointer"}
        // onClick={() => navigate("/orders/order-detail", { state: el.id })}
        >
          <DisplayData
            title={"INV Type"}
            v_color={"#169e49"}
            fw={"bold"}
            value={purchaseData.type}
          />
          <DisplayData
            title={"INV Date"}
            // fs={"16px"}
            // v_color={"#169e49"}
            // fw={"bold"}
            value={purchaseData.inv_date}
          />

          <DisplayData title={"INV Number"} value={purchaseData.inv_no} />
          <DisplayData title={"Vendor ID"} value={purchaseData.vendor_id} />

          <DisplayData
            title={"Total Amount"}
            value={formatCurrency(purchaseData.total_amount)}
          />
        </Card>

        <Heading fontSize={"xl"}>Products</Heading>
        <SimpleGrid minChildWidth="xs" spacing="10px">
          {purchaseData?.details?.map((el, i) => (
            <CustomDataCard
              key={el.id}
              data={createCustomerCardData(el)} // Show first 6 items
              keyWidth="100px"
              keyColor="gray.700"
              keyWeight="medium"
              valueColor="gray.600"
              valueAlign="left"
              shadow="lg"
            />
          ))}
        </SimpleGrid>
      </Stack>

      <ImageModal url={url} onClose={onClose} isOpen={isOpen} />
    </>
  );
};

export default PurchaseDetail;
